import React from 'react';
import { SettingsIcon } from 'lucide-react';
import { formatZAR } from '../hooks/useMavisData';
const tariffs = [{
  id: 'TRF-RES-01',
  name: 'Residential Lifeline (Indigent)',
  type: 'Prepaid',
  baseCharge: 0,
  blocks: [{
    range: '0 - 50 kWh',
    rate: 0.0
  }, {
    range: '51 - 350 kWh',
    rate: 1.85
  }, {
    range: '> 350 kWh',
    rate: 2.45
  }],
  activeMeters: 12450
}, {
  id: 'TRF-RES-02',
  name: 'Residential Standard',
  type: 'Prepaid',
  baseCharge: 0,
  blocks: [{
    range: '0 - 350 kWh',
    rate: 2.15
  }, {
    range: '351 - 600 kWh',
    rate: 2.65
  }, {
    range: '> 600 kWh',
    rate: 3.15
  }],
  activeMeters: 45200
}, {
  id: 'TRF-COM-01',
  name: 'Commercial Standard',
  type: 'Postpaid',
  baseCharge: 450.0,
  blocks: [{
    range: 'All kWh',
    rate: 2.85
  }],
  activeMeters: 3800
}, {
  id: 'TRF-IND-01',
  name: 'Industrial Time-of-Use (LPU)',
  type: 'Postpaid',
  baseCharge: 2500.0,
  blocks: [{
    range: 'Peak',
    rate: 4.5
  }, {
    range: 'Standard',
    rate: 1.95
  }, {
    range: 'Off-Peak',
    rate: 1.15
  }],
  activeMeters: 87
}];
export function TariffManagement() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-2688">
      {/* Header */}
      <div className="mb-8" data-id="element-2689">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2690">
          Tariff Management
        </h1>
        <p className="text-gray-500" data-id="element-2691">
          Configure and manage electricity tariff structures for all customer
          categories.
        </p>
      </div>

      <div className="space-y-6" data-id="element-2692">
        <div className="flex justify-end" data-id="element-2693">
          <button className="px-4 py-2 bg-mavis-teal text-white font-medium rounded-none hover:bg-mavis-teal/90 transition-colors shadow-sm text-sm" data-id="element-2694">
            + Create New Tariff
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2695">
          {tariffs.map(tariff => <div key={tariff.id} className="bg-white border border-gray-200 shadow-sm rounded-none overflow-hidden" data-id="element-2696">

              <div className="p-5 border-b border-gray-100 bg-gray-50 flex justify-between items-start" data-id="element-2697">
                <div data-id="element-2698">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2699">
                    <span className="text-xs font-mono text-gray-500" data-id="element-2700">
                      {tariff.id}
                    </span>
                    <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-none ${tariff.type === 'Prepaid' ? 'bg-mavis-green/10 text-mavis-green' : 'bg-mavis-blue/10 text-mavis-blue'}`} data-id="element-2701">

                      {tariff.type}
                    </span>
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-2702">
                    {tariff.name}
                  </h3>
                </div>
                <button className="p-2 text-gray-400 hover:text-mavis-teal transition-colors" data-id="element-2703">
                  <SettingsIcon className="w-5 h-5" data-id="element-2704" />
                </button>
              </div>
              <div className="p-5" data-id="element-2705">
                <div className="flex justify-between items-center mb-4 pb-4 border-b border-gray-100" data-id="element-2706">
                  <span className="text-sm text-gray-600" data-id="element-2707">
                    Fixed Monthly Charge
                  </span>
                  <span className="font-mono font-bold text-gray-900" data-id="element-2708">
                    {formatZAR(tariff.baseCharge)}
                  </span>
                </div>
                <div className="space-y-3" data-id="element-2709">
                  <p className="text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-2710">
                    Energy Rates (per kWh)
                  </p>
                  {tariff.blocks.map((block, idx) => <div key={idx} className="flex justify-between items-center text-sm" data-id="element-2711">

                      <span className="text-gray-700" data-id="element-2712">{block.range}</span>
                      <span className="font-mono font-medium text-mavis-teal" data-id="element-2713">
                        R {block.rate.toFixed(2)}
                      </span>
                    </div>)}
                </div>
              </div>
              <div className="p-4 bg-gray-50 border-t border-gray-100 text-xs text-gray-500 flex justify-between items-center" data-id="element-2714">
                <span data-id="element-2715">
                  Applied to {tariff.activeMeters.toLocaleString()} meters
                </span>
                <button className="text-mavis-teal font-medium hover:underline" data-id="element-2716">
                  View Meters
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}